import clsx from 'clsx';

import styles from './IconButton.module.css';
type Size = 's' | 'm';
type IconButtonProps = {
  size?: Size;
  icon: React.ReactNode;
  onClick?: () => void;
  buttonType?: 'button' | 'submit' | 'reset';
  disabled?: boolean;
  style?: React.CSSProperties;
  className?: string;
};

export function IconButton({
  size = 's',
  icon,
  onClick,
  buttonType = 'button',
  disabled = false,
  style,
  className,
}: IconButtonProps) {
  return (
    <button
      onClick={onClick}
      type={buttonType}
      disabled={disabled}
      className={clsx(styles.IconButton, size === 's' && styles.IconButton_s, className)}
      style={style}
    >
      {icon}
    </button>
  );
}
